import { render } from "./phone-button.vue?vue&type=template&id=1c8d2e9a"
import script from "./phone-button.vue?vue&type=script&lang=js"
export * from "./phone-button.vue?vue&type=script&lang=js"

import "./phone-button.vue?vue&type=style&index=0&id=1c8d2e9a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__